// eslint-disable-next-line import/extensions
import FormDuuf, { FormDuufField, FormDuufSubmit, FormDuufGroup, FormDuufProps } from './FormDuuf'
import useFormDuuf from './useFormDuuf'

export { FormDuufField, FormDuufSubmit, FormDuufGroup, useFormDuuf }
export type { FormDuufProps }

export default FormDuuf
